import * as XLSX from 'xlsx';

const asNumber = (value) => Number(value || 0);

const formatJakartaDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Asia/Jakarta',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
};

export const buildUnitWaterWorkbookData = (payload, t) => {
  const summary = payload?.summary || {};
  const unit = payload?.unit || {};
  const label = (key, fallback) => t(key, { defaultValue: fallback });

  const summaryRows = [
    { [label('units.export.summaryField', 'Field')]: label('units.export.stationId', 'Station ID'), [label('units.export.summaryValue', 'Value')]: unit.deviceId || unit.id || '' },
    { [label('units.export.summaryField', 'Field')]: label('units.export.stationName', 'Station name'), [label('units.export.summaryValue', 'Value')]: unit.deviceName || '' },
    { [label('units.export.summaryField', 'Field')]: label('units.export.period', 'Period'), [label('units.export.summaryValue', 'Value')]: payload?.period || '' },
    { [label('units.export.summaryField', 'Field')]: label('units.export.timezone', 'Timezone'), [label('units.export.summaryValue', 'Value')]: payload?.timezone || 'Asia/Jakarta' },
    { [label('units.export.summaryField', 'Field')]: label('units.export.transactionCount', 'Completed transactions'), [label('units.export.summaryValue', 'Value')]: asNumber(summary.transactionCount) },
    { [label('units.export.summaryField', 'Field')]: label('units.export.totalVolume', 'Total water (L)'), [label('units.export.summaryValue', 'Value')]: asNumber(summary.totalVolumeLiters) },
    { [label('units.export.summaryField', 'Field')]: label('units.export.chargedAmount', 'User debit (Rp)'), [label('units.export.summaryValue', 'Value')]: asNumber(summary.chargedAmount) },
    { [label('units.export.summaryField', 'Field')]: label('units.export.recognizedSales', 'Recognized sales (Rp)'), [label('units.export.summaryValue', 'Value')]: asNumber(summary.recognizedSalesAmount) },
    { [label('units.export.summaryField', 'Field')]: label('units.export.unrecognizedCount', 'Unrecognized transactions'), [label('units.export.summaryValue', 'Value')]: asNumber(summary.unrecognizedTransactionCount) }
  ];

  const detailRows = (payload?.rows || []).map((row) => ({
    [label('units.export.transactionId', 'Transaction ID')]: row.transactionId,
    [label('units.export.time', 'Time (Asia/Jakarta)')]: formatJakartaDateTime(row.occurredAt),
    [label('units.export.user', 'User')]: row.userName || '',
    [label('units.export.phone', 'Phone')]: row.userPhone || '',
    [label('units.export.cardType', 'Card type')]: row.cardType || '',
    [label('units.export.rfid', 'RFID')]: row.rfid || '',
    [label('units.export.waterType', 'Water type')]: row.waterType || '',
    [label('units.export.volume', 'Water (L)')]: asNumber(row.volumeLiters),
    [label('units.export.unitPrice', 'Price/L (Rp)')]: asNumber(row.pricePerLiter),
    [label('units.export.debit', 'User debit (Rp)')]: asNumber(row.chargedAmount),
    [label('units.export.fundingSource', 'Funding source')]: row.balanceSource || '',
    [label('units.export.recognized', 'Recognized revenue')]: row.recognizedRevenue
      ? label('units.export.recognizedYes', 'Yes')
      : label('units.export.recognizedNo', 'No'),
    [label('units.export.recognizedAmount', 'Recognized sales (Rp)')]: asNumber(row.recognizedSalesAmount)
  }));

  return { summaryRows, detailRows };
};

export const downloadUnitWaterWorkbook = (payload, t) => {
  const { summaryRows, detailRows } = buildUnitWaterWorkbookData(payload, t);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(summaryRows), 'Summary');
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(detailRows), 'Details');
  const station = String(payload?.unit?.deviceId || payload?.unit?.id || 'unit').replace(/[^a-zA-Z0-9_-]/g, '_');
  const period = String(payload?.period || 'period').replace(/[^0-9-]/g, '');
  XLSX.writeFile(workbook, `water-station-${station}-${period}.xlsx`);
};
